import React, { useEffect, useMemo } from "react";
import { ProviderFilter, ProviderFilterProps } from "./ProviderFilter";
import { SearchFilterStyleLegend, SearchFilterStyleLegendProp } from "./SearchFilter";
import _ from "lodash";
import { useProviderFilterWithFetch } from "./useProviderFilterWithFetch";
import { event as filterUseEvent } from "../GA/ExploreProviders/FilterUse";

const LProviderFilterWithFetch = () => {
    const { metadataLoading, metadataWithCount, searchParams, onSelectionChange } = useProviderFilterWithFetch();

    // const _onSelectionChange = useCallback(
    //     (key: string, value: string, checked: boolean) => {
    //         onSelectionChange(key, value, checked);
    //     },
    //     [onSelectionChange]
    // );
    const { providerType, ...rest } = metadataWithCount ?? {};

    const providerTypeLoading = metadataLoading;
    const providerTypeProps: SearchFilterStyleLegendProp = {
        loading: providerTypeLoading,
        label: "",
        options: [],
        ...providerType
    };

    // metadata is stil being loaded or cannot resolve search params with selections
    const filterLoading = metadataLoading || searchParams == null;

    const providerFilterProps: ProviderFilterProps = {
        filters: _.keys(rest)
            .map(key => {
                return {
                    key,
                    ...rest[key]
                };
            })
            .map(({ key, label, options }) => {
                return {
                    category: key,
                    label,
                    options,
                    onChange: onSelectionChange,
                    // _onSelectionChange,
                    checkValues: searchParams?.[key] ?? []
                };
            }),
        loading: filterLoading
    };

    const filterMessageEvent = useMemo(() => {
        return _.join(
            providerFilterProps?.filters
                ?.map(filter => {
                    if (!filter?.checkValues?.length) return null;

                    const label = filter?.label;
                    const optionValueToOption = _.keyBy(filter?.options, d => d.value);

                    const checkedLabels = _.join(
                        filter?.checkValues?.map(value => {
                            return `"${optionValueToOption?.[value]?.label}"`;
                        }),
                        " OR "
                    );

                    return `([${label}]: ${checkedLabels})`;
                })
                .filter(d => d != null),
            " AND "
        );
    }, [providerFilterProps]);

    useEffect(() => {
        filterUseEvent(filterMessageEvent);
    }, [filterMessageEvent]);

    return (
        <>
            <SearchFilterStyleLegend {...providerTypeProps} />
            <ProviderFilter {...providerFilterProps} />
        </>
    );
};

export const ProviderFilterWithFetch = LProviderFilterWithFetch;
